/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

function ReportePruebas() {
  // Datos mock para las estadísticas
  const statsData = [
    {
      color: "success",
      icon: "business",
      title: "Empresas Registradas",
      count: "127",
      percentage: {
        color: "success",
        amount: "+12%",
        label: "than last month",
      },
    },
    {
      color: "error",
      icon: "business_center",
      title: "Empresas No Registradas",
      count: "43",
      percentage: {
        color: "error",
        amount: "-8%",
        label: "than last month",
      },
    },
    {
      color: "info",
      icon: "quiz",
      title: "Test Usados",
      count: "2,847",
      percentage: {
        color: "success",
        amount: "+23%",
        label: "than last week",
      },
    },
    {
      color: "warning",
      icon: "help_outline",
      title: "Test No Usados",
      count: "156",
      percentage: {
        color: "warning",
        amount: "+5%",
        label: "than yesterday",
      },
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        {/* Header con la misma estructura que Empresas Registradas */}
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Reporte de Pruebas
                </MDTypography>
              </MDBox>
              <MDBox pt={3} pb={3} px={3}>
                <MDTypography variant="h5" gutterBottom>
                  Estadísticas Generales del Sistema
                </MDTypography>
                <MDTypography variant="body1" color="text">
                  Resumen de empresas registradas y el uso de pruebas en el sistema.
                </MDTypography>
              </MDBox>
            </Card>
          </Grid>
        </Grid>

        {/* Statistics Cards */}
        <MDBox mt={4}>
          <Grid container spacing={3}>
            {statsData.map((stat, index) => (
              <Grid item xs={12} md={6} lg={3} key={index}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    color={stat.color}
                    icon={stat.icon}
                    title={stat.title}
                    count={stat.count}
                    percentage={stat.percentage}
                  />
                </MDBox>
              </Grid>
            ))}
          </Grid>
        </MDBox>

        {/* Additional Information Section */}
        <MDBox mt={4}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Card>
                <MDBox pt={3} pb={3} px={3}>
                  <MDTypography variant="h6" gutterBottom>
                    Empresas Registradas vs No Registradas
                  </MDTypography>
                  <MDTypography variant="body2" color="text">
                    Del total de <strong>170 empresas</strong> en el sistema:
                  </MDTypography>
                  <MDBox mt={2}>
                    <MDBox display="flex" justifyContent="space-between" mb={1}>
                      <MDTypography variant="button" color="text">
                        Registradas:
                      </MDTypography>
                      <MDTypography variant="button" fontWeight="medium" color="success">
                        127 (74.7%)
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" justifyContent="space-between">
                      <MDTypography variant="button" color="text">
                        No Registradas:
                      </MDTypography>
                      <MDTypography variant="button" fontWeight="medium" color="error">
                        43 (25.3%)
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card>
                <MDBox pt={3} pb={3} px={3}>
                  <MDTypography variant="h6" gutterBottom>
                    Test Usados vs No Usados
                  </MDTypography>
                  <MDTypography variant="body2" color="text">
                    Del total de <strong>3,003 tests</strong> disponibles:
                  </MDTypography>
                  <MDBox mt={2}>
                    <MDBox display="flex" justifyContent="space-between" mb={1}>
                      <MDTypography variant="button" color="text">
                        Usados:
                      </MDTypography>
                      <MDTypography variant="button" fontWeight="medium" color="info">
                        2,847 (94.8%)
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" justifyContent="space-between">
                      <MDTypography variant="button" color="text">
                        No Usados:
                      </MDTypography>
                      <MDTypography variant="button" fontWeight="medium" color="warning">
                        156 (5.2%)
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ReportePruebas; 